export const iconFontAwesomeMedicalHealthHouseMedicalFlag = (
	<i className="fa-solid fa-house-medical-flag"></i>
);
